<template>
  <div class="social-sharing">
    <div class="social-sharing__title">
      {{ socialSharingDescription }}
    </div>
    <div class="social-sharing__options">
      <div class="social-sharing__options__option twitter" @click="shareOnTwitter">
        <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><path d="M496,109.5a201.8,201.8,0,0,1-56.55,15.3,97.51,97.51,0,0,0,43.33-53.6,197.74,197.74,0,0,1-62.56,23.5A99.14,99.14,0,0,0,348.31,64c-54.42,0-98.46,43.4-98.46,96.9a93.21,93.21,0,0,0,2.54,22.1,280.7,280.7,0,0,1-203-101.3A95.69,95.69,0,0,0,36,130.4C36,164,53.53,193.7,80,211.1A97.5,97.5,0,0,1,35.22,199v1.2c0,47,34,86.1,79,95a100.76,100.76,0,0,1-25.94,3.4,94.38,94.38,0,0,1-18.51-1.8c12.51,38.5,48.92,66.5,92.05,67.3A199.59,199.59,0,0,1,39.5,405.6,203,203,0,0,1,16,404.2,278.68,278.68,0,0,0,166.74,448c181.36,0,280.44-147.7,280.44-275.8,0-4.2-.11-8.4-.31-12.5A198.48,198.48,0,0,0,496,109.5Z"/></svg>
        Share on Twitter
      </div>
      <div class="social-sharing__options__option facebook" @click="shareOnFacebook">
        <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><path d="M455.27,32H56.73A24.74,24.74,0,0,0,32,56.73V455.27A24.74,24.74,0,0,0,56.73,480H256V304H202.45V240H256V189c0-57.86,40.13-89.36,91.82-89.36,24.73,0,51.33,1.86,57.51,2.68v60.43H364.15c-28.12,0-33.48,13.3-33.48,32.9V240h67l-8.75,64H330.67V480h124.6A24.74,24.74,0,0,0,480,455.27V56.73A24.74,24.74,0,0,0,455.27,32Z"/></svg>
        Share on Facebook
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    results: {
      type: Array
    }
  },
  computed: {
    socialSharingDescription () {
      if (this.$store.state.settings.socialSharing.description) {
        return this.$store.state.settings.socialSharing.description
      }
      return 'Share your results!'
    },
    tweetContent () {
      let untokenizedTweetContent = this.$store.state.settings.socialSharing.tweetContent
      if (this.$store.state.settings.socialSharing.conditionalShares && this.$store.state.settings.socialSharing.conditionalShares.length > 0) {
        const conditionalShares = this.$store.state.settings.socialSharing.conditionalShares
        conditionalShares.forEach(conditionalShare => {
          if (conditionalShare.condition.condition === 'first_result_is') {
            if (conditionalShare.condition.product === this.results[0].id) {
              untokenizedTweetContent = conditionalShare.tweetContent
            }
          }
        })
      }
      return this.tokenizeShareContent(untokenizedTweetContent)
    },
    facebookPostContent () {
      let untokenizedFacebookPostContent = this.$store.state.settings.socialSharing.facebookPostContent
      if (this.$store.state.settings.socialSharing.conditionalShares && this.$store.state.settings.socialSharing.conditionalShares.length > 0) {
        const conditionalShares = this.$store.state.settings.socialSharing.conditionalShares
        conditionalShares.forEach(conditionalShare => {
          if (conditionalShare.condition.condition === 'first_result_is') {
            if (conditionalShare.condition.product === this.results[0].id) {
              untokenizedFacebookPostContent = conditionalShare.facebookPostContent
            }
          }
        })
      }
      return this.tokenizeShareContent(untokenizedFacebookPostContent)
    }
  },
  methods: {
    tokenizeShareContent (untokenizedContent) {
      const tokens = ['%%result1%%', '%%result2%%', '%%result3%%', '%%siteurl%%']
      let tokenizedShareContent = untokenizedContent
      tokens.forEach(token => {
        if (untokenizedContent && untokenizedContent.includes(token)) {
          switch (token) {
            case '%%result1%%':
              if (this.results[0]) {
                tokenizedShareContent = tokenizedShareContent.replace('%%result1%%', this.results[0].name)
              }
              break
            case '%%result2%%':
              if (this.results[1]) {
                tokenizedShareContent = tokenizedShareContent.replace('%%result2%%', this.results[1].name)
              }
              break
            case '%%result3%%':
              if (this.results[2]) {
                tokenizedShareContent = tokenizedShareContent.replace('%%result3%%', this.results[2].name)
              }
              break
            case '%%siteurl%%':
              tokenizedShareContent = tokenizedShareContent.replace('%%siteurl%%', window.location.href)
              break
          }
        }
      })
      return tokenizedShareContent
    },
    shareOnTwitter () {
      const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(this.tweetContent)}`
      window.open(url, 'TwitterWindow', 'width=600,height=400')
    },
    shareOnFacebook () {
      const url = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}&quote=${this.facebookPostContent}`
      window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=600,height=400')
    }
  }
}
</script>

<style lang="scss" scoped>
.social-sharing {
  margin-top: 28px;
  text-align: center;

  .social-sharing__title {
    font-weight: 600;
    margin-bottom: 12px;
  }

  .social-sharing__options {

    .social-sharing__options__option {
      display: inline-block;
      padding: 12px 28px;
      background: red;
      color: white;
      margin: 0 6px;
      border-radius: 8px;
      cursor: pointer;

      svg {
        height: 18px;
        width: 18px;
        fill: white;
        vertical-align: middle;
        margin-right: 12px;
      }

      &.twitter {
        background: #00acee;
      }

      &.facebook {
        background: #3b5998;
      }
    }
  }
}
</style>
